// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"277":"d9ee9f18","970":"0b56eb7b"}[chunkId] + ".chunk.css";
};